// initial state
const state = {
    open: false,
    menu: [],
    menuItems: [],
    menuItemsMeta: {},
}

// mutations
const mutations = {
  open () {
    state.open = true 
  },
  close () {
    state.open = false
  },
  updateMenu (state, newMenu) {
    state.menu = newMenu
  },
  updateMenuItems (state, newMenuItems) {
    state.menuItems = newMenuItems
  },
  updateMenuItemsMeta (state, newMenuItemsMeta) {
    state.menuItemsMeta = newMenuItemsMeta
  }
}

export default {
  namespaced: true,
  state,
  mutations
}